import { SpatialHashGrid } from './SpatialHashGrid';

export interface InterferenceRegion {
  cellKey: string;
  bounds: { x: number; y: number; width: number; height: number };
  score: number;
  rayCount: number;
}

/**
 * Detects convergence zones where ray density and angular overlap
 * indicate interference should be simulated with FDTD.
 */
export class ConvergenceDetector {
  private threshold: number;

  constructor(threshold: number = 0.5) {
    this.threshold = threshold;
  }

  /** Find regions in the spatial grid that warrant field simulation */
  detect(spatialGrid: SpatialHashGrid): InterferenceRegion[] {
    const regions: InterferenceRegion[] = [];

    for (const cell of spatialGrid.getCells()) {
      if (cell.interferenceScore > this.threshold) {
        regions.push({
          cellKey: cell.key,
          bounds: cell.bounds,
          score: cell.interferenceScore,
          rayCount: cell.rayCount,
        });
      }
    }

    // Sort by score (highest first) so the manager prioritizes the most important regions
    regions.sort((a, b) => b.score - a.score);

    return regions;
  }

  setThreshold(threshold: number): void {
    this.threshold = threshold;
  }
}
